import React, { useEffect } from 'react';
import { browserHistory } from 'react-router';
import { getRegion } from 'utils/Region';

export const useRedirectToTalentPage = () => {
  const queryFromSearchPage = browserHistory?.getCurrentLocation()?.query;
  const redirectToTalentPage =
    queryFromSearchPage?.id && queryFromSearchPage?.q;
  useEffect(() => {
    if (redirectToTalentPage)
      return browserHistory.replace(
        `/${getRegion()}/talent/${
          queryFromSearchPage?.id
        }?name=${encodeURIComponent(queryFromSearchPage?.q)}`,
      );
  }, []);
};
